import styled from 'styled-components';
import { Wrapper } from '../Wrapper/Wrapper';
import { CustomRadio } from './RadioBase/RadioBase.styles';
import { HelperText } from '../HelperText/HelperText';

interface RadioWrapperProps {
  disabled?: boolean;
  checked?: boolean;
}

export const RadioWrapper = styled(Wrapper)<RadioWrapperProps>(({ checked, theme }) => ({
  padding: 4,
  borderRadius: 4,
  display: 'inline-flex',

  '&:hover:not([disabled])': {
    [`${CustomRadio}`]: {
      backgroundColor: checked ? theme.colors.primary['500'] : theme.colors.neutral['100'],
      boxShadow: theme.shadows['300'],
    },
  },
}));

interface LabelProps {
  disabled?: boolean;
}

export const Label = styled.label<LabelProps>(({ disabled, theme }) => ({
  fontFamily: theme.fontFamily,
  fontWeight: 500,
  fontSize: theme.fontSizes.body,
  display: 'inline-flex',
  cursor: disabled ? 'auto' : 'pointer',
  alignItems: 'flex-start',
  position: 'relative',
  userSelect: 'none',
  color: disabled ? theme.colors.neutral['400'] : theme.colors.neutral['700'],
  lineHeight: '16px',
}));

export const StyledHelperText = styled(HelperText)<{ disabled?: boolean }>(
  ({ disabled, theme }) => ({
    color: disabled ? theme.colors.neutral['400'] : theme.colors.neutral['500'],
  }),
);
